<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Ghostly Tales Of The Adirondacks</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="image-center"><img alt="Image" src="images/P6.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Page06.vue?63643f10